import { useMemo } from 'react';

/**
 * Builds the URL prefix for the learner course-consumption flow. `id` is the
 * `assignment_id` from the route. The course-player pages all hang off
 * `/learn/courses/:assignmentId`.
 */
export function useCourseRoutes(id: string | undefined) {
  return useMemo(() => {
    const safeId = id ?? '';
    return {
      base: `/learn/courses/${safeId}`,
      coursesIndex: '/learn/courses',
    };
  }, [id]);
}
